import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import classNames from "classnames";
import { linkStep } from "../../../redux/slices/navigation";
import { WiFi, WiFiEdit, GetQrLink } from "../../../redux/requests/wifi";
import { navigationStep } from "../../../redux/slices/navigation";
import { preloaderToggle } from "../../../redux/slices/preloader";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import ArrowDown from "../../../components/selectCategory/svg/ArrowDown";
import StepCustomize from "../../../components/stepCustomize";
import { Context } from "../../../components/saveFile/saveFile";
import s from "./WifiPage.scss?module";
import QrTitleField from "../../../components/input/qrTitleField";
import axios from "axios";
import { isNoEditRoute } from "../../../hooks/helpers";
import Form from "react-bootstrap/Form";
import InputText from "../../../components/input/inputText";
import { Col, Row } from "react-bootstrap";
import PopoverBtn from "../../../components/popoverBtn";
import useTypeDecription from "../../../hooks/useTypeDecription";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";

export default function WifiPage() {
  const { lang, getQrLinkSliceId, categoryChange } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo,
    getQrLinkSliceId: state.getQrLinkSlice.id,
    categoryChange: state.categories.categoryChange,
  }));
  const { id } = useParams();
  const navigate = useNavigate();
  const { saveWifi, setSaveWifi } = useContext(Context);
  const [wifi, setWifi] = useState([]);
  const { content, getContent } = useTypeDecription();
  const { checkErrorStatus } = useGetDataError();
  const { adminEntryLocation } = useCurrentLocation();

  const Encryptions = [
    { id: 1, type: "WPA/WPA2" },
    { id: 2, type: "WEP" },
    { id: 3, type: "NONE" },
    { id: 4, type: "RAW" },
  ];

  const [qrTitle, setQrTitle] = useState("");
  const [ssid, setSsid] = useState("");
  const [Encryption, setEncryption] = useState("WPA/WPA2");
  const [key, setKey] = useState("");
  const [empty, setEmpty] = useState(false);
  const [toggleSelect, setToggleSelect] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const dispatch = useDispatch();

  function reset() {
    dispatch(
      GetQrLink(() =>
        WiFiEdit([getQrLinkSliceId || id, ...wifi, categoryChange])
      )
    ).then(() => {
      if (!isNoEditRoute) {
        window.location.href = adminEntryLocation;
      }
    });
    dispatch(preloaderToggle(true));
    if (isNoEditRoute) {
      setSaveWifi([...wifi]);
      dispatch(navigationStep(3));
      navigate("/qr");
    }
  }

  function step() {
    if (getQrLinkSliceId || id) {
      return reset();
    } else if (!!wifi && wifi[2]?.length > 0) {
      dispatch(GetQrLink(() => WiFi([...wifi, categoryChange])));
      setSaveWifi([...wifi]), dispatch(preloaderToggle(true));
      dispatch(navigationStep(3));
      setEmpty(false);
      navigate("/qr");
    } else {
      setEmpty(true);
    }
  }

  useEffect(() => {
    getContent("wi-fi");
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/entry/wifi/get/${id}`)
        .then(({ data }) => {
          data[0]?.ssid && setSsid(data[0].ssid);
          data[0]?.password && setKey(data[0].password);
          data[0]?.encryption &&
            setEncryption(data[0].encryption.toUpperCase());
          setQrTitle(data.qrTitle);
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  useEffect(() => {
    if (ssid !== "") {
      dispatch(linkStep(true));
    } else {
      dispatch(linkStep(false));
    }
    setWifi([key, Encryption, ssid, qrTitle]);
  }, [key, Encryption, ssid, qrTitle]);

  useEffect(() => {
    if (saveWifi) {
      setKey(saveWifi[0]),
        setEncryption(saveWifi[1]),
        setSsid(saveWifi[2]),
        setQrTitle(saveWifi[3]);
    }
  }, [saveWifi]);

  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <InputText
            placeholder={lang.wifi[0]}
            type="text"
            value={ssid}
            onChange={(e) => setSsid(e.target.value)}
            popoverText={lang.wifi[25]}
          >
            {empty && (
              <Form.Text className="text-danger">
                Ssid cannot be empty
              </Form.Text>
            )}
          </InputText>

          <Row className="align-items-center flex-nowrap position-relative mb-3">
            <Col xs={12} md={11}>
              <div
                className={s.select}
                onClick={() => setToggleSelect(!toggleSelect)}
              >
                <div className={s.selectItemShow}>{Encryption}</div>
                <ArrowDown deg={toggleSelect ? 180 : 0} />
              </div>
              <div
                className={classNames(s.selectItems, {
                  [s.selectItemsActive]: toggleSelect,
                })}
              >
                {Encryptions?.map((i) => {
                  return (
                    <div
                      className={s.selectItem}
                      onClick={() => {
                        setToggleSelect(false);
                        setEncryption(i.type);
                      }}
                      key={i.id}
                    >
                      {i.type}
                    </div>
                  );
                })}
              </div>
            </Col>
            <div className="position-absolute top-0 end-0 mt-3 w-auto me-3">
              <PopoverBtn text={lang.wifi[26]} />
            </div>
          </Row>

          {Encryption !== "NONE" && (
            <InputText
              placeholder={lang.wifi[4]}
              type={isPasswordVisible ? "text" : "password"}
              value={key}
              onChange={(e) => setKey(e.target.value)}
              require={Encryption === "NONE" ? "false" : "true"}
              autoComplete="off"
              onFocus={() => setIsPasswordVisible(true)}
              onBlur={() => setIsPasswordVisible(false)}
              popoverText={lang.wifi[27]}
            >
              {empty && (
                <Form.Text className="text-danger">
                  Ssid cannot be empty
                </Form.Text>
              )}
            </InputText>
          )}

          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>

        <StepCustomize emulate={step} disabled={!wifi || !wifi[2]?.length} />
      </SecondScreen>
      {isNoEditRoute && content}
    </>
  );
}
